<script lang="ts">
  export let repo = '';
</script>

<a href={`https://github.com/${repo}`} target="_blank"><slot /></a>
